import { schema } from 'normalizr';

const preferences = [new schema.Entity('preferences', {}, { idAttribute: 'sendingFacilityId' })];

const PreferencesSchemas = {
	PREFERENCES: preferences
};

export default PreferencesSchemas;